import { config } from '@/config';
import { transientState } from './TransientState';

const SCOPES = 'admin';

export class AuthFlow {
  private constructor() {}

  static create(): AuthFlow {
    return new AuthFlow();
  }

  clientId(): string {
    return config.testModeEnabled ? config.authClientIdTest : config.authClientIdLive;
  }

  establishSessionUrl(): string {
    const url = new URL('/auth/session', window.location.origin);
    url.searchParams.set('clientId', this.clientId());
    url.searchParams.set('scopes', SCOPES);
    return url.toString();
  }

  enter(): void {
    window.location.href = this.establishSessionUrl();
  }

  redirectToSignIn(): void {
    if (transientState.establishAlreadyAttempted()) {
      return;
    }
    transientState.saveScrollPosition();
    transientState.markEstablishAttempted();
    const returnTo = encodeURIComponent(
      `${window.location.pathname}${window.location.search}${window.location.hash}`
    );
    window.location.href = `/auth/redirect?reason=expired&returnTo=${returnTo}`;
  }
}

export const authFlow = AuthFlow.create();
